// Singleton store instance shared by ES-module consumers.
//
// Single source of truth for the app store: every consumer imports `store`
// from this file. Devtools access via `window.__magviz.store` (set in
// src/app/main.js); no other window globals are involved.
//
// `params` is the reactive params proxy onto the store — modules that
// previously received it through a deps bag can import it here directly.
// The pane reads/writes params.<key>; non-UI callers should prefer
// store.dispatch(intent) so the intent handler owns the side-effect chain.

import { createStore } from './store';
import { initialState } from './defaults';
import { createStateProxy } from './proxy';
import type { ParamsState, State } from './schema';

export const store = createStore<State>(initialState);
export const params = createStateProxy<ParamsState>(store as unknown as import('./store').Store<object>, 'params');
